import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "⏱️", key: "fiveMinutes" },
  { emoji: "🕒", key: "fifteenMinutes" },
  { emoji: "🕐", key: "thirtyMinutes" },
  { emoji: "💎", key: "asLongAsNeeded" },
]

export default function PetsMistakeCostPage() {
  return (
    <RadioCardListPage translationKey="petsMistakeCost" options={OPTIONS} />
  )
}
